import React from 'react';
import { Icon, IconSize, IconType, LogoImage, Header2Text } from 'ui-toolkit';
import { LogoHolder } from './LogoHolder';
import { CenterMessage } from './MessageView.styled';

interface IIsSuccessViewProps {}

export const SuccessDisplay: React.FC<IIsSuccessViewProps> = () => (
  <div>
    <LogoHolder>
      <LogoImage />
    </LogoHolder>
    <CenterMessage>
      <Icon type={IconType.Check} size={IconSize.Large} />
      <Header2Text data-test-id={'success-message'}>Order Created!</Header2Text>
    </CenterMessage>
  </div>
);
